import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';
import { SharedModule } from '@bb-vendure/admin-ui/core';

/**
 * A control for setting the number of items per page in a paginated list.
 */
@Component({
    standalone : true,
    imports : [SharedModule],
    selector: 'custom-items-per-page-controls',
    templateUrl: './items-per-page-controls.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CustomItemsPerPageControlsComponent {
    @Input() itemsPerPage = 10;
    @Output() itemsPerPageChange = new EventEmitter<number>();
}
